import React from 'react';

interface AvatarProps {
     initials: string;
     name: string;
     backgroundColor?: string;
    style?: React.CSSProperties;
}

const Avatar: React.FC<AvatarProps> = ({ initials, name, backgroundColor = '#6b47dc', style  }) => {


     return (
          <div className="avatar-badge-container">
               <div className="avatar" style={{ backgroundColor, ...style }}>
                    <span className="initials">{initials}</span>
               </div>
          </div>
     );
};

export default Avatar;
